import app from '../../../main'

export default {
    namespaced: true,
    state: {
        brands: [],
        mobileBrands: [],
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 10
        },
        errors: {
            getBrands: {}
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        CLEAR_BRANDS(state) {
            state.brands = []
            state.mobileBrands = []
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalProducts: 0,
                pageSize: 10
            }
        },
        SET_BRANDS(state, payload) {
            state.brands = payload
        },
        SET_MOBILE_BRANDS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileBrands = payload
            } else {
                state.mobileBrands = [...state.mobileBrands, ...payload]
            }
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        }
    },
    actions: {
        clearBrands({ commit }) {
            commit('CLEAR_BRANDS')
        },
        async getBrands({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'getBrands',
                val: {}
            })

            const url = '/supplier/statistics/global/brands'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    }
                })
                app.$Progress.finish()

                commit('SET_BRANDS', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: resp.headers['page'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: resp.headers['total-pages'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalProducts',
                    val: resp.headers['total-records'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: resp.headers['page-size'] * 1
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_BRANDS', resp.data)
                }
            } catch (e) {
                app.$Progress.fail()
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getBrands',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getBrands',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
